var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43520",
    "data-name": "Group 43520",
    transform: "translate(7682 20752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16121",
    "data-name": "Rectangle 16121",
    width: 24,
    height: 24,
    transform: "translate(-7682 -20752)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connection",
    transform: "translate(-7680.5 -20750.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3129",
    "data-name": "Ellipse 3129",
    cx: 4.121,
    cy: 4.121,
    r: 4.121,
    transform: "translate(6.379 6.379)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.525,
    cy: 1.525,
    r: 1.525,
    transform: "translate(8.975 8.975)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3131",
    "data-name": "Ellipse 3131",
    cx: 2.434,
    cy: 2.434,
    r: 2.434,
    transform: "translate(2.133)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132",
    "data-name": "Ellipse 3132",
    cx: 1.752,
    cy: 1.752,
    r: 1.752,
    transform: "translate(8.748 17.496)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133",
    "data-name": "Ellipse 3133",
    cx: 2.194,
    cy: 2.194,
    r: 2.194,
    transform: "translate(14.541 0.83)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134",
    "data-name": "Ellipse 3134",
    cx: 2.133,
    cy: 2.133,
    r: 2.133,
    transform: "translate(0 12.907)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3135",
    "data-name": "Ellipse 3135",
    cx: 2.133,
    cy: 2.133,
    r: 2.133,
    transform: "translate(16.735 13.432)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3342",
    "data-name": "Line 3342",
    x1: 1.975,
    y1: 2.684,
    transform: "translate(6.009 4.395)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3343",
    "data-name": "Line 3343",
    y1: 2.626,
    x2: 2.19,
    transform: "translate(13.14 4.708)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3344",
    "data-name": "Line 3344",
    y1: 1.557,
    x2: 2.869,
    transform: "translate(4.008 12.466)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3345",
    "data-name": "Line 3345",
    y1: 2.875,
    transform: "translate(10.5 14.621)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3346",
    "data-name": "Line 3346",
    x1: 2.968,
    y1: 1.796,
    transform: "translate(14.075 12.664)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.c61befdb637bd34da7f94197cbdd0cc5.svg";
export { ForwardRef as ReactComponent };